<template>
  <article class="article-card">
    <div class="article-card-content">
      <span class="article-category">{{ post.category }}</span>
      <h3>
        <router-link :to="articlePath">{{ post.title }}</router-link>
      </h3>
      <p class="article-meta">Published: {{ publishedMonth }} | {{ post.readTime }}</p>
      <p class="article-excerpt">{{ post.excerpt }}</p>
      <router-link :to="articlePath" class="read-more">Read More →</router-link>
    </div>
  </article>
</template>

<script>
import { formatPublishedMonth } from '@/data/blog-content';

export default {
	name: 'ArticleCard',
	props: {
		post: {
			type: Object,
			required: true,
		},
	},
	computed: {
		articlePath() {
			return `/blog/${this.post.slug}/`;
		},
		publishedMonth() {
			return formatPublishedMonth(this.post);
		},
	},
};
</script>
